import TextWithImageRight2 from './TextWithImageRight2';

export default TextWithImageRight2;